import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ExecuteForm from '../forms/execute-form';
import { executeValidationSchema } from '../schema/execute.js';

export default function ExecuteNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Execute Node Details',
        altText: 'Execute Node',
        defaultLabel: data?.command || 'Execute Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={ExecuteForm} schemaResolver={executeValidationSchema} />
    </NodeProvider>
  );
}
